/**
 * @module actions/customers
 */
import axios from 'axios'
import {
  API_URL,
  SET_EMPLOYEES
} from '../constants'

/**
 * @description Getting employees from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getEmployees (id) {
  id = (typeof id !== 'undefined') ? id : 0
  let url = API_URL + '/Employee/' + id
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_EMPLOYEES,
        employees: res.data
      })
      return res
    })
  }
}

/**
 * @description Getting customer from API
 * @return {Promise} Axios promise
 */
export function getEmployee (id) {
  let url = API_URL + '/Employee/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creating/saving a customer
 * @return {Promise} Axios promise
 */
export function CreateSaveEmployee (data) {
  let url = API_URL + '/Employee/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Creating/saving a customer
 * @return {Promise} Axios promise
 */
export function ChangePassword (data) {
  let url = API_URL + '/Users/ChangePassword'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Saving workhours
 * @return {Promise} Axios promise
 */
export function UpdateWorkHours (data) {
  let url = API_URL + '/Employee/Workhours/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get workhourLogs
 * @return {Promise} Axios promise
 */
export function GetWorkHourLogs (UserId) {
  let url = API_URL + '/Employee/Get/HistoricalWorkHours/' + UserId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Create base userinfo for employee
 * @return {Promise} Axios promise
 */
export function CreateEmployee (data) {
  let url = API_URL + '/Employee/Create/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting user Support Access  from API
 * @return {Promise} Axios promise
 */
export function getImpersonationAccess () {
  let url = API_URL + '/Employee/ImpersonationAccess/Get/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description saving user Support Access
 * @return {Promise} Axios promise
 */
export function saveImpersonationAccess (data) {
  let url = API_URL + '/Employee/ImpersonationAccess/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/employees.js